import { render, staticRenderFns } from "./HazardIcon.vue?vue&type=template&id=15beccb2&"
import script from "./HazardIcon.vue?vue&type=script&lang=js&"
export * from "./HazardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports